import axios from '../axios';

export const show = (lang = null) => {
  const params = lang
    ? {
        lang,
      }
    : {};

  return axios.get('/statute', {
    params,
  });
};

export const submit = (payload) => {
  return axios.post('/statute', payload);
};
